/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';
import { Bus, FileUp, UserRound } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
type Tipo = 'veiculo' | 'condutor' | 'monitor';
async function arquivo(f: File) {
  const bytes = new Uint8Array(await f.arrayBuffer()),
    hash = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', bytes)))
      .map((x) => x.toString(16).padStart(2, '0'))
      .join(''),
    conteudoBase64 = btoa(Array.from(bytes, (x) => String.fromCharCode(x)).join(''));
  return { tipo: 'DOCUMENTO_CADASTRAL', nome: f.name, hashSha256: hash, conteudoBase64 };
}
function Tela({ tipo }: { tipo: Tipo }) {
  const ns = `/bff/v1/j05-s01-cadastrar-${tipo}`,
    [s, setS] = useState<any>(),
    [dados, setDados] = useState<Record<string, string>>({}),
    [doc, setDoc] = useState<any>(),
    key = useRef(crypto.randomUUID());
  async function call(p: string, b?: unknown) {
    const x = await chamarApi<any>(ns + p, { metodo: p === '/state' ? 'GET' : 'POST', corpo: b });
    setS(x.state);
  }
  useEffect(() => {
    void call('/state'); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando cadastro…
      </main>
    );
  const veiculo = tipo === 'veiculo';
  return (
    <main className="mx-auto w-full max-w-4xl space-y-5 px-4 py-6">
      <header>
        <p className="text-sm text-muted-foreground">J-05 · Frota e equipe</p>
        <h1 className="text-3xl font-semibold">{s.titulo}</h1>
        <p>{s.descricao}</p>
      </header>
      {s.alertas?.map((a: any, i: number) => (
        <div role="alert" className="rounded-md border border-destructive p-3" key={i}>
          {a.mensagem}
        </div>
      ))}
      <section className="grid gap-3 rounded-md border p-4">
        <h2 className="font-semibold">Dados do recurso</h2>
        {veiculo ? (
          <>
            <label>
              Placa
              <input
                className="mt-1 w-full rounded-md border bg-background p-2"
                onChange={(e) => setDados({ ...dados, placa: e.target.value })}
              />
            </label>
            <label>
              Marca
              <input
                className="mt-1 w-full rounded-md border bg-background p-2"
                onChange={(e) => setDados({ ...dados, marca: e.target.value })}
              />
            </label>
            <label>
              Modelo
              <input
                className="mt-1 w-full rounded-md border bg-background p-2"
                onChange={(e) => setDados({ ...dados, modelo: e.target.value })}
              />
            </label>
            <label>
              Ano
              <input
                inputMode="numeric"
                className="mt-1 w-full rounded-md border bg-background p-2"
                onChange={(e) => setDados({ ...dados, ano: e.target.value })}
              />
            </label>
            <label>
              Capacidade
              <input
                inputMode="numeric"
                className="mt-1 w-full rounded-md border bg-background p-2"
                onChange={(e) => setDados({ ...dados, capacidade: e.target.value })}
              />
            </label>
          </>
        ) : (
          <>
            <label>
              CPF
              <input
                inputMode="numeric"
                className="mt-1 w-full rounded-md border bg-background p-2"
                onChange={(e) => setDados({ ...dados, cpf: e.target.value })}
              />
            </label>
            <label>
              Nome
              <input
                className="mt-1 w-full rounded-md border bg-background p-2"
                onChange={(e) => setDados({ ...dados, nome: e.target.value })}
              />
            </label>
            {tipo === 'condutor' && (
              <>
                <label>
                  CNH
                  <input
                    className="mt-1 w-full rounded-md border bg-background p-2"
                    onChange={(e) => setDados({ ...dados, registro: e.target.value })}
                  />
                </label>
                <label>
                  Categoria
                  <input
                    className="mt-1 w-full rounded-md border bg-background p-2"
                    onChange={(e) => setDados({ ...dados, categoria: e.target.value })}
                  />
                </label>
              </>
            )}
            <label>
              Validade
              <input
                type="date"
                className="mt-1 w-full rounded-md border bg-background p-2"
                onChange={(e) => setDados({ ...dados, validade: e.target.value })}
              />
            </label>
          </>
        )}
        <label>
          <FileUp className="mr-2 inline h-4 w-4" />
          Documento
          <input
            type="file"
            className="mt-1 block w-full"
            onChange={(e) => e.target.files?.[0] && void arquivo(e.target.files[0]).then(setDoc)}
          />
        </label>
        <Button
          disabled={!doc}
          onClick={() =>
            void call('/verbs/cadastrar', { dados, documento: doc, chaveIdempotencia: key.current })
          }
        >
          Enviar para análise
        </Button>
      </section>
      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Recursos cadastrados</h2>
        {s.recursos.map((r: any) => (
          <article className="rounded-md border p-4" key={r.id}>
            <h3 className="font-medium">
              {veiculo ? (
                <Bus className="mr-2 inline h-5 w-5" />
              ) : (
                <UserRound className="mr-2 inline h-5 w-5" />
              )}
              {r.nome || r.identificador}
            </h3>
            <p>
              {r.identificador} · {r.estado}
            </p>
            {r.documentos?.map((d: any) => (
              <p className="wrap-break-word text-sm" key={d.id}>
                {d.nome} · versão {d.versao} · {d.status}
              </p>
            ))}
          </article>
        ))}
      </section>
      <nav className="flex flex-wrap gap-3">
        {s.navegacao.map((n: any) => (
          <a className="text-link underline" href={n.caminho} key={n.caminho}>
            {n.rotulo}
          </a>
        ))}
      </nav>
    </main>
  );
}
export const VeiculosCredenciadoPage = () => <Tela tipo="veiculo" />;
export const CondutoresCredenciadoPage = () => <Tela tipo="condutor" />;
export const MonitoresCredenciadoPage = () => <Tela tipo="monitor" />;
